"use strict";

$(function () {
  //ページトップをクリックしたらページの一番上へ移動する
  $("#pageTop").on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
  });

  $("#ghMenuBtn").on("click", function () {
    if (window.innerWidth < 1280) {
      $("body").toggleClass("isOpen");
      $(this).toggleClass("isOpen");
      $(".ghMenu").slideToggle();
    }
  });

  setTimeout(function () {

    var pos = 0;
    let before = $(window).scrollTop();

    $(window).on('scroll', function () {
      let after = $(this).scrollTop();
      if (after < before || $(this).scrollTop() < 100) {　//上スクロール時の処理を記述
        $('#globalHeader').removeClass('isFixed');
      } else {　//下スクロール時の処理を記述
        $('#globalHeader').addClass('isFixed');
      }
      before = after;
      pos = $(this).scrollTop();
    });
  }, 1000);



  // $(function () {
  var urlHash = location.hash;
  var headH = $("#globalHeader").innerHeight();
  if (urlHash) {
    setTimeout(function () {
      $("#globalHeader").removeClass("isFixed");
    }, 0);
  }

  $("a[href^='#']").not(".noScroll").not(".modalLink").click(function () {
   var headH = $("#globalHeader").innerHeight();
    var opt = 0;
    var speed = 600;
    var href = $(this).attr("href");
    var target = $(href === "#" || href === "" ? 'html' : href);
    var position = target.offset().top - opt;
    if (document.getElementById("careerHeader") != null) { //キャリア採用$("#careerHeader")が存在したらtrue
    headH = $("#careerHeader").innerHeight();
    position = target.offset().top - headH;
   }
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
  //  });

  // header タブ
  var selectBox = $(".ghLanguageBtnWrap .ghLanguageList");
  var selectItems = $(".ghLanguageBtnWrap .ghLanguageList >  li");
  var display = $(".ghLanguageBtnWrap .ghLanguageBtn");

  selectBox.hide();

  display.on("click", function () {
    $(this).next('.ghLanguageList').slideToggle();
    $(this).toggleClass("isOpen");
  })

  // セカンドメニューの制御
  if (window.matchMedia("(min-width: 1281px)").matches) {
    $(".ghNavList > li").hover(
      function () {
        const $ghNavChild = $(this).find(".ghNavChild");
        if ($ghNavChild.length) {
          $ghNavChild.stop().slideDown(400);
        }
      },
      function () {
        const $ghNavChild = $(this).find(".ghNavChild");
        if ($ghNavChild.length) {
          $ghNavChild.stop().slideUp(400);
        }
      }
    );
  } else {
    //sp menu
    $(".ghNavList > li > p").on("click", function () {
      $(this).next(".ghNavChild").slideToggle();
      $(this).toggleClass("isOpen");
    });

    $(".ghNavList > li > p > a").on("click", function () {
      $(this).parent().next(".ghNavChild").slideToggle();
      $(this).parent().toggleClass("isOpen");
    });
  }


  $('.newsNavBtn').click(function () {
    $('.newsNavBtn').removeClass('isActive');
    var active = $(this).attr('id').replace('newsNav', 'newsContent');
    $('.newsContent').removeClass('isActive');
    $(this).addClass('isActive');
    $('#' + active).addClass('isActive');
  });

    // ヘッダーの高さを取得（適宜変更）
    var headerHeight = $("header").innerHeight();

    // URLに#（アンカー）が付いているか確認
    if (window.location.hash) {
        var target = $(window.location.hash);

        if (target.length) {
            // 少し遅らせてスクロール位置を調整
            setTimeout(function() {
                $("html, body").animate({
                    scrollTop: target.offset().top - headerHeight
                }, 0);
            }, 100);
        }
    }  

});


    
$(window).on("scroll", function () {
    // 言語メニューを閉じる
  $(".ghLanguageBtnWrap .ghLanguageBtn").removeClass("isOpen");
  $(".ghLanguageList").slideUp();
  
  // ナビゲーションメニューを閉じる
  $(".ghNavList > li > p").removeClass("isOpen");
  $(".ghNavList > li > p > a").removeClass("isOpen");
  $(".ghNavChild").slideUp();
});